module.exports = __webpack_public_path__ + "img/Dantam Bridal 25.9117271d.jpg";